import { ExperimentId } from 'core/type/ExperimentId';
import { getBootstrapConfig } from 'core/window/windowService';
import * as availability from 'component/page/detail/store/availability.types';
import * as availabilityDEPRECATED from 'component/page/detail/store/availabilityDEPRECATED.types';

const config = getBootstrapConfig();
const isNewImplementationEnabled = config.experiments[ExperimentId.ACT_4944];

export type EnrichedBookingRequirement = typeof isNewImplementationEnabled extends true
    ? availabilityDEPRECATED.EnrichedBookingRequirement
    : availability.EnrichedBookingRequirement;

export type BookingRequirementState = typeof isNewImplementationEnabled extends true ? availabilityDEPRECATED.BookingRequirementState : availability.BookingRequirementState;

export type SelectedOfferState = typeof isNewImplementationEnabled extends true ? availabilityDEPRECATED.SelectedOfferState : availability.SelectedOfferState;

export type SelectedOfferCard = typeof isNewImplementationEnabled extends true ? availabilityDEPRECATED.SelectedOfferCard : availability.SelectedOfferCard;

export const OfferNotificationType = isNewImplementationEnabled ? availabilityDEPRECATED.OfferNotificationType : availability.OfferNotificationType;

export const ContinueYourBookingNotificationType = isNewImplementationEnabled
    ? availabilityDEPRECATED.ContinueYourBookingNotificationType
    : availability.ContinueYourBookingNotificationType;

export type OfferOptionsState = typeof isNewImplementationEnabled extends true ? availabilityDEPRECATED.OfferOptionsState : availability.OfferOptionsState;
